export const REFERRER_PATH_STORAGE_KEY = 'referrer_path_storage';

export const getLocalStorageReferrer = (): string[] => {
  if (typeof window === 'undefined') {
    return [];
  }

  const storedReferrer = localStorage.getItem(REFERRER_PATH_STORAGE_KEY);

  return storedReferrer ? JSON.parse(storedReferrer) : [];
};

export const setLocalStorageItems = (items: string[]): void => {
  if (typeof window === 'undefined') {
    return;
  }

  localStorage.setItem(REFERRER_PATH_STORAGE_KEY, JSON.stringify(items));
};
